import { ILink } from '../interfaces/ILink';
import {
  HOVER_FACEBOOK_LINK,
  HOVER_LINKEDIN_LINK,
  HOVER_TWITTER_LINK,
} from './links';
import { ILinksGroup } from '../interfaces/ILinksGroup';

export const BOTTOM_ITEMS: Array<ILink> = [
  {
    to: `/privacy/`,
    label: 'Privacy',
  },
  {
    to: '',
    label: 'Cookie Settings',
  },
  {
    to: `/terms-of-use/`,
    label: 'Terms of use',
  },
  {
    to: HOVER_TWITTER_LINK,
    label: 'Twitter',
  },
  {
    to: HOVER_FACEBOOK_LINK,
    label: 'Facebook',
  },
  {
    to: HOVER_LINKEDIN_LINK,
    label: 'Linkedin',
  },
];

export const LINK_DESKTOP: ILinksGroup = [
  {
    label: 'For Professionals',
    links: [
      {
        label: 'Exterior contractors',
        to: `/exterior-contractors/`,
      },
      { label: 'Insurance', to: `/insurance/` },
      {
        label: 'Restoration',
        to: `/restoration/`,
      },
      {
        label: 'Architects',
        to: `/architects/`,
      },
      {
        label: 'Tips and tricks',
        to: `/blog/?from=tips`,
      },
    ],
  },
  {
    label: 'Product',
    links: [
      { label: 'Pricing', to: `/pricing/` },
      {
        label: 'HOVER Reports',
        to: `/reports/`,
      },
      {
        label: 'Sales solutions',
        to: `/product/`,
      },
      {
        label: 'Production tools',
        to: `/transform-plan/`,
      },
      { label: 'Integrations', to: `/partners/`, isExternal: true },
    ],
  },
  {
    label: 'For Homeowners',
    links: [
      {
        label: 'How it works',
        to: `/how-it-works/`,
      },
      {
        label: 'Invited by a contractor',
        to: `/invited-by-contractor/`,
      },
      {
        label: 'Invited by an insurer',
        to: `/invited-by-insurance/`,
      },
    ],
  },
  {
    label: 'Resources',
    links: [
      { label: 'Blog', to: `/blog/` },
      { label: 'Support', to: 'https://support.hover.to', isExternal: true },
      {
        label: 'Developers',
        to: 'https://developers.hover.to',
        isExternal: true,
      },
    ],
  },
  {
    label: 'company',
    links: [
      { label: 'About', to: `/about/` },
      { label: 'Press', to: `/press/` },
      { label: 'Careers', to: `/careers/` },
      { label: 'Contact us', to: `/contact/` },
    ],
  },
];

export const LINK_MOBILE: ILinksGroup = [
  {
    label: 'For Professionals',
    links: [
      {
        label: 'Exterior contractors',
        to: `/exterior-contractors/`,
      },
      { label: 'Insurance', to: `/insurance/` },
      {
        label: 'Restoration',
        to: `/restoration/`,
      },
      {
        label: 'Architects',
        to: `/architects/`,
      },
      {
        label: 'Tips and tricks',
        to: `/blog/?from=tips`,
      },
    ],
  },
  {
    label: 'For Homeowners',
    links: [
      {
        label: 'How it works',
        to: `/how-it-works/`,
      },
      {
        label: 'Invited by a contractor',
        to: `/invited-by-contractor/`,
      },
      {
        label: 'Invited by an insurer',
        to: `/invited-by-insurance/`,
      },
    ],
  },
  {
    label: 'Product',
    links: [
      { label: 'Pricing', to: `/pricing/` },
      {
        label: 'HOVER Reports',
        to: `/reports/`,
      },
      {
        label: 'Sales solutions',
        to: `/product/`,
      },
      {
        label: 'Production tools',
        to: `/transform-plan/`,
      },
      { label: 'Integrations', to: `/partners/`, isExternal: true },
    ],
  },
  {
    label: 'Resources',
    links: [
      { label: 'Blog', to: `/blog/` },
      { label: 'Support', to: 'https://support.hover.to', isExternal: true },
      {
        label: 'Developers',
        to: 'https://developers.hover.to',
        isExternal: true,
      },
    ],
  },
  {
    label: 'company',
    links: [
      { label: 'About', to: `/about/` },
      { label: 'Press', to: `/press/` },
      { label: 'Careers', to: `/careers/` },
      { label: 'Contact us', to: `/contact/` },
    ],
  },
];
